// The deployment environments the SPA can run in, matching the ENV value each
// config/*.js sets on window.env. Runtime config is the ONLY thing that tells
// stage and production apart — CI builds one JS artifact and swaps config.js
// per environment — so anything that needs to branch on environment resolves
// against this list rather than a build-time flag.
export const APP_ENVS = ["local", "stage", "production"];
// Sentry project ingest keys shared by the SPA (src/utils/ErrorReporting.ts)
// and the BFF (packages/bff/src/lib/sentry.ts). Not secrets — public
// write-only IDs scoped to each Sentry project. Kept here so the two
// runtimes can't drift, and so neither directly depends on the other.
export const SENTRY_DSN_BY_ENV = {
    local: "https://57cef12fc4b54defbd199e2acf3ab7b3@sentry.io/305459",
    stage: "https://f93cfde40ae84b909ba84ef72562a84e@sentry.io/305466",
    production: "https://cee1c78453e54eab94c560be7886fad6@sentry.io/305469"
};
//# sourceMappingURL=index.js.map